<!--课程业务-->
<template>
  <div  class="app-container">
    <div class="title-container" shadow="never" style="margin-top: 10px;">
      <div class="title-con">
        <i class="el-icon-tickets"></i>
        <span style="margin-left: 5px;">数据列表</span>
      </div>
      <div>
      </div>
    </div>
    <div class="table-container" style="margin-top: 0px;">
      <el-table ref="tableData"
                :data="tableData"
                v-loading="tableloading" border
                highlight-current-row
                :header-cell-style="{'text-align':'center'}"
                :cell-style="{'text-align':'center'}"
                @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="100"></el-table-column>
        <el-table-column prop="templateName" label="课程模板名"></el-table-column>
        <el-table-column prop="type" label="课程类型"></el-table-column>
        <el-table-column prop="price" label="售价(元)"></el-table-column>
        <el-table-column label="操作" >
          <template slot-scope="scope">
            <el-button @click="handleChangePriceDlg(scope.row)" type="danger" plain size="small">修改价格</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      title="新增"
      :visible.sync="visibleDlgAdd"
      width="50%"
      center>
      <div class="edit-area">
        <el-form label-width="150px">
          <el-form-item label="课程模板名:">
            <el-input v-model="createParam.templateName" placeholder="输入模板名" style="width: 300px;"></el-input>
          </el-form-item>
          <el-form-item label="类型:">
            <el-input v-model="createParam.type" placeholder="" style="width: 300px;"></el-input>
          </el-form-item>
          <el-form-item label="售价(元):">
            <el-input-number v-model="createParam.price" placeholder="" ></el-input-number>
          </el-form-item>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleDlgAdd = false">取消</el-button>
        <el-button type="primary" @click="handleCreateOne()">确认</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="修改价格"
      :visible.sync="visibleDlgChangePrice"
      width="50%"
      center>
      <div class="edit-area">
        <el-form label-width="150px">
          <el-form-item label="课程模板名:">
            <el-input v-model="changePriceParam.templateName" :readonly="true" style="width: 300px;"></el-input>
          </el-form-item>
          <el-form-item label="类型:">
            <el-input v-model="changePriceParam.type" :readonly="true" style="width: 300px;"></el-input>
          </el-form-item>
          <el-form-item label="售价(元):">
            <el-input-number v-model="changePriceParam.price" placeholder="0" ></el-input-number>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleDlgChangePrice = false">取消</el-button>
        <el-button type="primary" @click="handleChangePriceOne()">确认</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="删除课程模板"
      :visible.sync="visibleDlgDelete"
      width="50%"
      center>
      <div class="edit-area">
        <el-form label-width="150px">
          <el-form-item label="课程模板名:">
            <el-input v-model="deleteParam.templateName" :readonly="true" style="width: 300px;"></el-input>
          </el-form-item>
          <el-form-item label="类型:">
            <el-input v-model="deleteParam.type" :readonly="true" style="width: 300px;"></el-input>
          </el-form-item>
          <el-form-item label="售价(元):">
            <el-input v-model="deleteParam.price" :readonly="true" style="width: 300px;"></el-input>
          </el-form-item>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleDlgDelete = false">取消</el-button>
        <el-button type="primary" @click="handleDeleteOne()">删除</el-button>
      </span>
    </el-dialog>
  </div>


</template>
<style scoped>
  /deep/ .el-table th.el-table__cell>.cell{
    width: 90%;
    height: auto;
    background: #ecf3fd;
    border-radius: 8px;
  }
  /deep/ .el-table__header-wrapper .cell{
    line-height: 45px;
    color: #0d6fb8;
  }
  /deep/ .el-dialog--center{
    border: 2px solid #d0d0d0;
    border-radius: 10px;
  }
  /deep/ .el-dialog__header{
    border-radius: 10px;
    background: #f0f7ff;
  }

</style>

<script>
  import {
    changeLessontpPrice,
    createLessonTemplate,
    delLessonTemplate,
    fechListLessonTemplate
  } from "../../../api/superAdmin";
  import commonUtils from "../../../utils/commonUtils";
  import messageUtils from "../../../utils/messageUtils";

  export default {
    data() {
      return {

        visibleDlgAdd:false,

        visibleDlgDelete:false,

        visibleDlgChangePrice:false,

        //表单结果
        tableData: [
        ],
        tableloading: true,
        createParam :{
          templateName:"",
          type:'',
          price: ""
        },
        changePriceParam:{
          templateName:'',
          type :'',
          price :''
        },
        deleteParam :{
          templateName:'',
          type :'',
          price :''
        }

      }
    },
    created(){
      this.fetchList();
    },
    mounted() {

    },
    methods: {

      fetchList(){
        this.tableloading = true;
        fechListLessonTemplate().then(response => {
          let date = response.data;
          if (commonUtils.isObjectNull(date)){
            return;
          }
          this.refreshData(date);
          this.tableloading = false;
        })
      },

      //刷新页面数据
      refreshData(list){
        if (commonUtils.isObjectNull(list)){
          return;
        }
        let tableDataList = [];
        for (let i = 0;i< list.length;++i){
          let data = {
            number : i+1 ,
            id: list[i].id,
            templateName:list[i].templateName,
            type: list[i].type,
            price :  list[i].price
          };
          tableDataList.push(data);
        }

        this.tableData = tableDataList;
      },

      //点击查询按钮
      onBtnSearch(){
        this.$message('点击查询');
      },
      handleSelectionChange(val) {

        this.multipleSelection = val;
      },

      handleChangePriceDlg(row){
        this.changePriceParam = {
          id :row.id,
          templateName :row.templateName,
          type :row.type,
          price :row.price,
        }
        this.visibleDlgChangePrice = true;
      },


      handleChangePriceOne(){

        let param = {
          id :this.changePriceParam.id,
          price:this.changePriceParam.price
        }
        changeLessontpPrice(param).then(response =>
        {
          let date = response.data;
          if (commonUtils.isObjectNull(date)){
            return;
          }
          this.visibleDlgChangePrice = false;
          messageUtils.successMsg(this,response.message);
          this.fetchList();

        })
      },
      handleDeleteOneShhowLog(row){
        this.deleteParam = {
          id :row.id,
          templateName :row.templateName,
          type :row.type,
          price :row.price,
        }
        this.visibleDlgDelete = true;
      },
      handleDeleteOne(){

        let param = {
          id :this.deleteParam.id
        }
        delLessonTemplate(param).then(response =>
        {
          let date = response.data;
          if (commonUtils.isObjectNull(date)){
            return;
          }
          messageUtils.successMsg(this,"删除成功");
          this.fetchList();
          this.visibleDlgDelete = false;
        })
      },

      handleCreateOne(){
        let param = {
          templateName :this.createParam.templateName,
          type :this.createParam.type,
          price : this.createParam.price
        }
        createLessonTemplate(param).then(response =>
        {
          let date = response.data;
          if (commonUtils.isObjectNull(date)){
            return;
          }
          messageUtils.successMsg(this,"添加成功");
          this.fetchList();
          this.visibleDlgAdd = false;
        })
      }
    }
  }
</script>






// WEBPACK FOOTER //
// src/views/superadmin/lesson-template/index.vue